import { VlocPendingDisbursement } from '@varo/graphql-schema-types';
import { Stack } from 'expo-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { HomeTileTypeIds } from 'shared/hooks/homeTiles/HomeTileTypeIds';
import useRefreshHomeTiles from 'shared/hooks/homeTiles/useRefreshHomeTiles';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

type TVlocIsOnItsWayProps = {
  data?:
    | VlocPendingDisbursement
    | {
        title?: string;
        description?: string;
      };
  serializedData?: undefined;
};

const VlocIsOnItsWayScreen = ({ data }: TVlocIsOnItsWayProps) => {
  const { t: translatedText } = useTranslation('vloc', {
    keyPrefix: 'vlocIsOnItsWay',
  });

  useViewDidFocusScreenAnalyticsEvent({
    key: '/varo-line-of-credit/vloc-is-on-its-way',
  });

  const dismissToTab = useDismissToRootTab();

  const goToHome = () => {
    dismissToTab(Tabs.HOME);
  };

  useBackHandler(goToHome);

  const { refreshTiles } = useRefreshHomeTiles([
    HomeTileTypeIds.INTERNAL_ACCOUNT_TILE_CHECKING,
    HomeTileTypeIds.VLOC_ACCOUNT_CARD_SQUARE_TILE,
    HomeTileTypeIds.VXL_SIDE_BY_SIDE_TILE_ACCOUNT_CARD,
    HomeTileTypeIds.VXL_TRACKER_CARD_TILE_CREDIT_TRACKER,
  ]);

  useEffect(() => {
    refreshTiles();
  }, [refreshTiles]);

  return (
    <View style={styles.container}>
      <Stack.Screen options={{ headerShown: false, gestureEnabled: false }} />
      <SuccessScreen
        primaryButton={{
          label: translatedText('button'),
          analyticsId: 'vloc_is_on_its_way_goToHomeClicked',
          customAttributes: { cta: 'Done' },
          onPress: goToHome,
        }}
        visual="HOURGLASS_A"
        titleText={data?.title ?? ''}
        content={
          <BodyBaseText style={styles.contentText} numberOfLines={0}>
            {data?.description ?? ''}
          </BodyBaseText>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  contentText: {
    textAlign: 'center',
  },
});

export default VlocIsOnItsWayScreen;
